<template>
  <el-row class="container1">
    <el-col :span="24" class="main1">
      <section class="content-container1">
        <!-- <div class="content-wrapper"> -->
        <el-breadcrumb separator="/" class="navTop">
          <el-breadcrumb-item
            v-for="(item,index) in realList"
            :key="index"
            :to="item.path"
          >{{item.name}}</el-breadcrumb-item>
        </el-breadcrumb>
        <el-col :span="24">
          <transition name="fade" mode="out-in">
            <router-view></router-view>
          </transition>
        </el-col>
        <!-- </div> -->
      </section>
    </el-col>
  </el-row>
</template>

<script>
import { mapGetters } from "vuex";
import menuList from "../components/menuList.vue";
import { getCustomerInfo, updatePassword } from "../api/configApi.js";
import teacherInfoVue from "./configurable/teacherInfo.vue";
export default {
  data() {
    return {
      sysName: "",
      collapsed: false,
      sysUserName: "",
      role: JSON.parse(sessionStorage.getItem("userinfo")).role,
      realList: [],
      dialogVisible: false,
      rules: {
        password: [
          {
            required: true,
            min: 3,
            max: 10,
            message: "请输入正确的格式",
            regex: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{3,10}$/
          } //密码正则表达式字母和数字的组合
        ]
      },
      formparam: {
        password: ""
      },
      logoUrl: ""
    };
  },
  computed: {
    ...mapGetters(["permission_routers"])
  },
  components: {
    menuList
  },
  methods: {
    getConfigInfo() {
      getCustomerInfo().then(res => {
        if (res.msg == "success") {
          sessionStorage.setItem("logo", res.data.logo);
          this.logoUrl = res.data.logo;
        }
      });
    },
    onSubmit() {
      console.log("submit!");
    },
    handleopen() {},
    handleclose() {
      //console.log('handleclose');
    },
    handleselect: function(a, b) {},
    //修改密码
    changePassword() {
      this.dialogVisible = true;
      this.formparam.password = "";
    },
    submitSetInfo(formparam) {
      this.$refs[formparam].validate(valid => {
        if (valid) {
          updatePassword(this.formparam).then(res => {
            if (res.msg == "success") {
              this.dialogVisible = false;
              this.$message({
                type: "success",
                message: "修改成功"
              });
              this.dialogVisible = false;
            } else {
              this.$message({
                type: "error",
                message: res.data
              });
            }
          });
        } else {
          this.$message.error("请检查必填项");
          return false;
        }
      });
    },
    resetForm(formparam) {
      this.dialogVisible = false;
      this.$refs[formparam].clearValidate();
    },
    //退出登录
    logout() {
      this.$confirm("确认退出吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          //   sessionStorage.removeItem("userinfo");
          //   sessionStorage.removeItem("token");
          //   sessionStorage.removeItem("shopList");
          //   sessionStorage.removeItem("menuList");
          //   sessionStorage.removeItem("limitInfo");
          sessionStorage.clear();
          sessionStorage.setItem("flag", 0);
          this.$router.push("/login");
        })
        .catch(error => {
          this.$message.error("已经取消");
        });
    },
    getinfo(item, index) {
      console.log(item, index);
    },
    //折叠导航栏
    collapse: function() {
      this.collapsed = !this.collapsed;
    },
    showMenu(i, status) {
      this.$refs.menuCollapsed.getElementsByClassName(
        "submenu-hook-" + i
      )[0].style.display = status ? "block" : "none";
    },
    getRoutePath() {
      this.realList = this.$route.meta.routeList;
    }
  },
  mounted() {
    // console.log(this.$router.options.routes)
    var userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
    if (userinfo) {
      this.sysUserName = userinfo.userName;
    }
    this.getRoutePath();
    if (sessionStorage.getItem("logo")) {
      this.logoUrl = sessionStorage.getItem("logo");
    } else {
      this.getConfigInfo();
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.routeList = to.meta.routeList;
    });
  }
};
</script>

<style lang="scss" scoped>
// @import '~scss_vars';
.container {
  .main {
    .content-container {
      width: 100%;
      min-width: 1400px;
      position: relative;
      overflow: hidden;
      // padding: 20px;
      background: #f2f2f2;
    }
  }
}
element.style {
  padding-left: 20px;
  color: #fff;
  background-color: #0087c4;
}
.el-submenu__title i {
  color: #fff;
}
.el-menu-item i {
  color: #fff;
}
.el-menu-item.is-active {
  color: #fff601;
  background: #2db3f0 !important;
}

//滚动条的宽度
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
//滚动条的滑块
::-webkit-scrollbar-thumb {
  background-color: #a1a3a9;
  border-radius: 8px;
}
</style>


// WEBPACK FOOTER //
// Main.vue?b849442a